export default __webpack_public_path__ + "static/media/fruit-768w.8572c40a.png";